import { msg } from '@lingui/macro'

export const NOTIFICATION_PAGE_SIZE = 30
export const NOTIFICATION_SEARCH_DEBOUNCE_MS = 400

/** Must match ActionLogFeedTab on the API. */
export const NOTIFICATION_TABS = Object.freeze({
  ALL: 'all',
  UNREAD: 'unread',
  CRASHES: 'crashes',
  USERS: 'users',
  SYSTEM: 'system',
})

/** Must match ActionLogCategory on the API. */
export const NOTIFICATION_CATEGORIES = Object.freeze({
  CRASH_ADDED: 'crash_added',
  CRASH_MODIFIED: 'crash_modified',
  CRASH_DELETED: 'crash_deleted',
  CRASH_VALIDATED: 'crash_validated',
  OFFLINE_IMPORT: 'offline_import',
  USER: 'user',
  CRASH_REQUIRES_VALIDATION: 'crash_requires_validation',
  HOSPITAL_EXIT_DATE: 'hospital_exit_date',
  OTHER: 'other',
})

export const NOTIFICATION_TAB_ITEMS = [
  { id: NOTIFICATION_TABS.ALL, label: msg`All` },
  { id: NOTIFICATION_TABS.UNREAD, label: msg`Unread` },
  { id: NOTIFICATION_TABS.CRASHES, label: msg`Crashes` },
  { id: NOTIFICATION_TABS.USERS, label: msg`Users` },
  { id: NOTIFICATION_TABS.SYSTEM, label: msg`System` },
]

export const NOTIFICATION_TARGETS = Object.freeze({
  CRASH: 'crash',
  USERS: 'users',
  ZIP_IMPORTS: 'zipImports',
  CSV_IMPORTS: 'csvImports',
  NONE: 'none',
})

export const NOTIFICATION_VIEW_AVAILABILITY = Object.freeze({
  ENABLED: 'enabled',
  DESKTOP_ONLY: 'desktopOnly',
  NONE: 'none',
})

export const NOTIFICATION_CRASH_LOAD_RESULTS = Object.freeze({
  SHOWN: 'shown',
  NO_COORDINATES: 'noCoordinates',
  NOT_FOUND: 'notFound',
  ERROR: 'error',
})

export const EMPTY_NOTIFICATION_FILTERS = Object.freeze({
  dateFrom: null,
  dateTo: null,
  userId: '',
  category: '',
  organization: '',
})

/** Basic organization types ("database" filter); must match BasicOrganizationEnum on the API. */
export const NOTIFICATION_DATABASE_OPTIONS = [
  { value: 1, label: msg`Police` },
  { value: 2, label: msg`Healthcare` },
  { value: 3, label: msg`Insurance` },
]

export const NOTIFICATION_DAY_GROUPS = Object.freeze({
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  EARLIER: 'earlier',
})
